import { useGridApiRef } from "@mui/x-data-grid-premium";
import { Outlet } from "react-router";

import HotelPanel from "./arrival/components/HotelPanel";
import HotelPlanningTabs from "./components/HotelPlanningTabs";

/** Single ref shared by the active tab: departure table or clinic unassigned table (one outlet child at a time). */
function HotelPlanningLayout() {
    const api = useGridApiRef();
    return (
        <HotelPanel>
            <div className="flex flex-col h-full overflow-auto">
                <HotelPlanningTabs apiRef={api} />
                <Outlet context={{ api }} />
            </div>
        </HotelPanel>
    );
}

export default HotelPlanningLayout;
